export default "__VITE_ASSET__BYu2BeD3__"